import React from "react";
import { Grid } from "@mui/material";
import { Stack, Typography } from "@financeable-com-au/financeable-ui";
import moment from "moment";
import { PPSR_CERTIFICATE_DOCUMENT_NAME } from "@/constants";
import { PPSRDetailsProps } from "@/utils/interface";
import { PPSRSearchResponse, SecuredParty } from "@/store/slices/types/applicationFormSlice";
// @ts-expect-error: ignoring as it is existing js file
import Document from "../CustomerDetails/Document";

const PPSRDetails = ({ asset }: PPSRDetailsProps) => {
  const ppsrDocuments = asset?.documents?.filter((doc) => doc.documentType === PPSR_CERTIFICATE_DOCUMENT_NAME);
  return (
    <React.Fragment>
      {asset?.blueflagPPSR?.search?.length > 0 ? (
        <Grid item xs={12} mb={2}>
          <Grid container item direction="row" mt="10px">
            <Grid item sm={1.5} xs={12} lg={1.5}>
              <Typography level="body-md" fontWeight={600} style={{ margin: "0 0 5px" }}>
                Type
              </Typography>
            </Grid>
            <Grid item sm={4.5} xs={12} lg={5}>
              <Typography level="body-md" fontWeight={600} style={{ margin: "0 0 5px" }}>
                Security group
              </Typography>
            </Grid>
            <Grid item sm={2} xs={12} lg={2}>
              <Typography level="body-md" fontWeight={600} style={{ margin: "0 0 5px" }}>
                Proceeds Claimed
              </Typography>
            </Grid>
            <Grid item sm={2} xs={12} lg={2}>
              <Typography level="body-md" fontWeight={600} style={{ margin: "0 0 5px" }}>
                Start date
              </Typography>
            </Grid>
            <Grid item sm={2} xs={12} lg={1.5}>
              <Typography level="body-md" fontWeight={600} style={{ margin: "0 0 5px" }}>
                End date
              </Typography>
            </Grid>
          </Grid>
          {asset?.blueflagPPSR?.search.map((searchResult: PPSRSearchResponse, index: number) => (
            <Grid
              key={searchResult?.registration_detail?.registration_number || searchResult?.result_sequence_number || index}
              container
              item
              direction="row"
            >
              <Grid item sm={1.5} xs={12} lg={1.5}>
                <Typography level="body-sm" style={{ margin: "0 0 2px" }}>
                  {searchResult?.registration_detail?.collateral_class_description}
                </Typography>
              </Grid>
              <Grid item sm={4.5} xs={12} lg={5}>
                <Typography level="body-sm" style={{ margin: "0 0 2px" }}>
                  {searchResult?.registration_detail?.secured_parties?.map((group: SecuredParty, groupIndex: number) => (
                    <Stack key={group?.organisation?.organisation_name || groupIndex}>
                      {group?.organisation?.organisation_name}
                    </Stack>
                  ))}
                </Typography>
              </Grid>
              <Grid item sm={2} xs={12} lg={2}>
                <Typography level="body-sm" style={{ margin: "0 0 2px" }}>
                  {searchResult?.registration_detail?.are_proceeds_claimed}
                </Typography>
              </Grid>
              <Grid item sm={2} xs={12} lg={2}>
                <Typography level="body-sm" style={{ margin: "0 0 2px" }}>
                  {moment(searchResult?.registration_detail?.registration_start_time).format("DD-MM-YYYY")}
                </Typography>
              </Grid>
              <Grid item sm={2} xs={12} lg={1.5}>
                <Typography level="body-sm" style={{ margin: "0 0 2px" }}>
                  {moment(searchResult?.registration_detail?.registration_end_time).format("DD-MM-YYYY")}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Grid item xs={12} mb={2}>
          <Stack alignItems="center" justifyContent="center">
            <Typography level="body-md" style={{ margin: "0 0 2px" }}>
              No PPSR data available
            </Typography>
          </Stack>
        </Grid>
      )}
      {ppsrDocuments?.length > 0 && (
        <Grid container direction="row" mt="10px">
          <Stack spacing={1} direction="row" style={{ margin: "0 0 10px" }}>
            {ppsrDocuments?.map((doc, docIndex) => (
              <Document key={doc?._id || doc?.url || docIndex} document={doc} name="ppsr" />
            ))}
          </Stack>
        </Grid>
      )}
    </React.Fragment>
  );
};

export default PPSRDetails;
